import React, { useCallback, useEffect, useState } from "react";
import { ExternalLink, FileText, Send } from "lucide-react";
import { api } from "../../lib/api";
import { getBlob } from "../../lib/attachments";
import HoverPreview from "../HoverPreview";
import DemarcheSendDialog from "./DemarcheSendDialog";

const ACTIONS = [
  { step: "mairie", label: "Envoyer la demande mairie", pv: false },
  { step: "raccordement", label: "Envoyer la demande de raccordement", pv: true },
  { step: "tva", label: "Envoyer la demande de TVA", pv: true },
];

export const openFile = async (dossierId, f) => window.open(URL.createObjectURL(await getBlob(dossierId, f)), "_blank");

export function MairieDocs({ dossierId, refresh }) {
  const [files, setFiles] = useState([]);
  useEffect(() => {
    api.get(`/dossiers/${dossierId}/tab-data/documents`).then((r) => setFiles(((r.data.attachments || {}).mairie_decision || []).map((a) => ({ ...a, kind: "tab", tab: "documents" }))))
      .catch(() => setFiles([]));
  }, [dossierId, refresh]);
  if (!files.length) return <span className="text-[11px] italic text-norea-textDisabled" data-testid="mairie-docs-empty">Aucun document mairie reçu</span>;
  return (
    <div className="flex flex-wrap gap-1.5" data-testid="mairie-docs">
      {files.map((f, i) => (
        <HoverPreview key={f.id} dossierId={dossierId} file={f} className="inline-flex" testid={`mairie-doc-preview-${i}`}>
          <button onClick={(e) => { e.stopPropagation(); openFile(dossierId, f); }} className="inline-flex items-center gap-1 rounded-full border border-norea-border bg-white px-2 py-0.5 text-[11px] hover:bg-norea-surfaceHover"
            data-testid={`mairie-doc-open-${i}`}><FileText className="w-3 h-3" />{f.filename}<ExternalLink className="w-3 h-3 opacity-60" /></button>
        </HoverPreview>
      ))}
    </div>
  );
}

export default function DemarchesActions({ dossier, onSent }) {
  const [step, setStep] = useState(null);
  const [k, setK] = useState(0);
  const isPv = (dossier.extraction?.produit || "").toUpperCase() === "PV";
  const close = useCallback(() => setStep(null), []);
  return (
    <section className="card-flat p-4 space-y-3" data-testid="demarches-actions">
      <div className="flex flex-wrap items-center gap-2">
        {ACTIONS.filter((a) => !a.pv || isPv).map((a) => (
          <button key={a.step} onClick={() => setStep(a.step)} className="btn-secondary text-xs inline-flex items-center gap-1.5" data-testid={`demarche-send-${a.step}`}>
            <Send className="w-3.5 h-3.5" />{a.label}</button>
        ))}
        <span className="text-[11px] text-norea-textMuted">Destinataires et modèles provisoires (LUMOS / VD2E) — à valider par Norea.</span>
      </div>
      <div className="flex items-center gap-2 text-xs"><b className="shrink-0">Documents mairie (récépissé, accord, refus)</b><MairieDocs dossierId={dossier.id} refresh={k} /></div>
      <p className="text-[11px] text-norea-textMuted">Un récépissé ou un arrêté rangé dans « Mairie Accord / Récépissé / Refus » est lu par l'IA : date de récépissé, date d'accord tacite, date d'accord et statut sont remplis.</p>
      <DemarcheSendDialog dossierId={dossier.id} step={step} onClose={close} onSent={() => { setK((x) => x + 1); onSent?.(); }} />
    </section>
  );
}
